import React from 'react';
import LinkedInButton from '../ui/LinkedInButton';

export default function Footer() {
  return (
    <footer className="bg-brand-deep text-brand-cream/60 py-12 text-sm font-light">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-start md:items-center gap-12">
        
        <div>
          <a href="#" className="font-serif text-2xl text-brand-cream tracking-wide block mb-2">
            Clarity<span className="text-brand-terra">90</span>
          </a>
          <p>Mugdha Yelkar &copy; {new Date().getFullYear()}</p>
          <p>Fractional COO | Creator, Clarity90</p>
        </div>

        <div className="flex flex-col md:items-end gap-6">
          <LinkedInButton />
          
          <div className="flex flex-col md:text-right gap-2">
            <a href="mailto:mugdha@clarity90.in" className="text-brand-cream/80 hover:text-brand-cream transition-colors font-medium">
              mugdha@clarity90.in
            </a>
            <a href="https://www.clarity90.in" className="hover:text-brand-cream transition-colors">
              www.clarity90.in
            </a>
          </div>
        </div>

      </div>
    </footer>
  );
}